/** Caps timeline events in the interest context slice, keeping the newest items. */
export const ASSISTANT_INTEREST_TIMELINE_MAX_EVENTS = 20;
